import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function UploadIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M2.91663 3.5L11.0833 3.5C11.4055 3.5 11.6666 3.23883 11.6666 2.91667C11.6666 2.5945 11.4055 2.33333 11.0833 2.33333L2.91663 2.33333C2.59446 2.33333 2.33329 2.5945 2.33329 2.91667C2.33329 3.23883 2.59446 3.5 2.91663 3.5Z'
        fill={props.color ?? '#46484D'}
      />
      <path
        d='M11.6666 4.08337V2.91671C11.6666 2.59454 11.4055 2.33337 11.0833 2.33337C10.7611 2.33337 10.5 2.59454 10.5 2.91671V4.08337C10.5 4.40554 10.7611 4.66671 11.0833 4.66671C11.4055 4.66671 11.6666 4.40554 11.6666 4.08337Z'
        fill={props.color ?? '#46484D'}
      />
      <path
        d='M3.5 4.08337V2.91671C3.5 2.59454 3.23883 2.33337 2.91667 2.33337C2.5945 2.33337 2.33333 2.59454 2.33333 2.91671V4.08337C2.33333 4.40554 2.5945 4.66671 2.91667 4.66671C3.23883 4.66671 3.5 4.40554 3.5 4.08337Z'
        fill={props.color ?? '#46484D'}
      />
      <path
        d='M4.66671 8.16662C4.57615 8.16662 4.48683 8.14554 4.40583 8.10504C4.32483 8.06454 4.25438 8.00574 4.20004 7.93329C4.15408 7.872 4.12064 7.80227 4.10162 7.72806C4.08261 7.65385 4.0784 7.57663 4.08924 7.50079C4.10007 7.42496 4.12573 7.352 4.16476 7.28608C4.20379 7.22017 4.25542 7.16258 4.31671 7.11662L6.65004 5.36662C6.74994 5.29362 6.87047 5.25427 6.99421 5.25427C7.11794 5.25427 7.23847 5.29362 7.33837 5.36662L9.67171 7.01162C9.79747 7.10083 9.88279 7.23621 9.90902 7.38815C9.93526 7.54009 9.90027 7.69624 9.81171 7.82245C9.7675 7.88554 9.71123 7.93925 9.64615 7.98048C9.58108 8.0217 9.50848 8.04963 9.43255 8.06264C9.35662 8.07566 9.27887 8.07351 9.20377 8.05631C9.12868 8.03912 9.05774 8.00722 8.99504 7.96245L7.00004 6.55662L5.01671 8.04995C4.91573 8.12568 4.79292 8.16662 4.66671 8.16662Z'
        fill={props.color ?? '#46484D'}
      />
      <path
        d='M6.99996 12.25C6.84525 12.25 6.69688 12.1885 6.58748 12.0791C6.47808 11.9697 6.41663 11.8213 6.41663 11.6666V6.99996C6.41663 6.84525 6.47808 6.69688 6.58748 6.58748C6.69688 6.47808 6.84525 6.41663 6.99996 6.41663C7.15467 6.41663 7.30304 6.47808 7.41244 6.58748C7.52183 6.69688 7.58329 6.84525 7.58329 6.99996V11.6666C7.58329 11.8213 7.52183 11.9697 7.41244 12.0791C7.30304 12.1885 7.15467 12.25 6.99996 12.25Z'
        fill={props.color ?? '#46484D'}
      />
    </SvgIcon>
  );
}
